import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './api-base.token';
import { AdminUser, CreateUserRequest, UpdateUserRequest } from './models';

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  list() {
    return this.http.get<AdminUser[]>(`${this.apiBaseUrl}/api/users`);
  }

  create(payload: CreateUserRequest) {
    return this.http.post<AdminUser>(`${this.apiBaseUrl}/api/users`, payload);
  }

  update(id: string, payload: UpdateUserRequest) {
    return this.http.patch<AdminUser>(`${this.apiBaseUrl}/api/users/${id}`, payload);
  }

  delete(id: string) {
    return this.http.delete<boolean>(`${this.apiBaseUrl}/api/users/${id}`);
  }
}
